import { CustomTableParams } from '@/models/custom-table-params.model';
import { CustomTableMeta } from '@/models/custom-table-meta.model';
import { CustomTableColumn } from '@/models/custom-table-column.model';
import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class CustomTableControls extends Vue {
    @Prop() public inFlight: boolean;
    @Prop() public tableColumns: CustomTableColumn[];
    @Prop() public tableMeta: CustomTableMeta;
    @Prop() public tableParams: CustomTableParams;

    public changeSize(newSize: any) {
        const newSizeInt = parseInt(newSize, 10);
        this.$emit('onTableParamsShouldUpdate', { size: newSizeInt, page: 1 });
    }

    public changePage(newPage: number) {
        this.$emit('onTableParamsShouldUpdate', { page: newPage });
    }

    public nextPage() {
        const nextPage = Math.min(this.tableParams.page + 1, this.tableMeta.totalPages);
        this.changePage(nextPage);
    }

    public prevPage() {
        const nextPage = Math.max(this.tableParams.page - 1, 0);
        this.changePage(nextPage);
    }

    public getPaginationOptions() {
        if (this.tableMeta.totalPages < 8) {
            return this.tableMeta.totalPages;
        }

        const page = this.tableParams.page;
        const totalPages = this.tableMeta.totalPages;

        if (page >= 6 && !(page > totalPages - 4)) {
            return [1, '...', page - 1, page, page + 1, '...', totalPages];
        } else if (page > totalPages - 4) {
            return [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
        } else {
            return [1, 2, 3, 4, 5, '...', totalPages];
        }
    }
}
